
import React, { useEffect, useState } from "react";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { CloseIcon, SwapGrayIcon, SwapIcon } from "../../../assets/images";
import { RadioContainer } from "../../commons";
import { HRMS_PERFORMANCE_EVALAUTION_SORTING } from "../../../constant/tableHeadersConstants/checkInScheduleListHeader";



type AppProps = {
  handleChange: (data: any) => void;
  selectedData: { name: string; value: string; id: string };
  type?:string;
};

const PerformanceEvaluationSorting = ({ handleChange, selectedData , type }: AppProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [sortingData, setSortingData] = useState({ name: "", value: "",id:"" });

  const handleRadioValueChange = (data: any) => {
    let filteredData = HRMS_PERFORMANCE_EVALAUTION_SORTING?.find(
      (item: any) => item?.id === data
    );
  
    if (filteredData) {
      setSortingData(filteredData);
    }
   

    setIsOpen(!isOpen);
  };
 

  useEffect(() => {
    if(sortingData?.id){
      handleChange(sortingData);
    }
    
  }, [sortingData]);

  return (
    <div>
      <ButtonDropdown
        isOpen={isOpen}
        toggle={() => {
          setIsOpen(!isOpen);
        }}
      >
        <DropdownToggle
          caret
          color="secondary"
          style={
            isOpen
              ? {
                  color: "#dd4433",
                  border: "1px solid #dd4433",
                  backgroundColor: "#fff6f5",
                }
              : { border: "1px solid#bfcbe1" }
          }
          outline
        >
          <img src={selectedData?.value ? SwapIcon : SwapGrayIcon} alt="" />
        </DropdownToggle>

        <DropdownMenu right>
          <div className="pr-2 pl-2 sort-menu" style={{ width: "250px" }}>
            <div style={{ padding: "5px" }}>
              <div className="d-flex justify-content-between mt-0 mb-0">
                <h5 className="text-center ">Sort By</h5>
                <div
                  className="pointer"
                  onClick={() => {
                    setIsOpen(!isOpen);
                  }}
                >
                  <img src={CloseIcon} alt="" />
                </div>
              </div>
              <hr className="mt-0 mb-0" />
              <RadioContainer
                optionsList={HRMS_PERFORMANCE_EVALAUTION_SORTING}
                handleSetRadioValue={handleRadioValueChange}
                radioValue={
                  selectedData?.name ? selectedData?.name : "Newest first"
                }
                alignment="vertical"
                backGround={true}
              />
            </div>
          </div>
        </DropdownMenu>
      </ButtonDropdown>
    </div>
  );
};

export default PerformanceEvaluationSorting;

